
import { Body, Controller, Post } from '@nestjs/common';
import {  CommonResponseModel } from '@needle-management/shared-models';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { NeedleReturnAfterProductionService } from './needle-return-after-production.service';
import { NeedleReturnAfterProductionDto } from './needle-return-after-production.dto';

@Controller('/needleReturnAfterProduction')
@ApiTags('/needleReturnAfterProduction')
export class NeedleReturnAfterProductionController {
    constructor(
        private service: NeedleReturnAfterProductionService,
    ) {}

    @Post('/createNeedleReturnProduction')
    @ApiBody({ type: NeedleReturnAfterProductionDto })
    async createNeedleReturnProduction(@Body() req: any): Promise<CommonResponseModel> {
        return await this.service.createNeedleReturnProduction(req);
    }

    @Post('/getAllNeedleReturnProduction')
    async getAllNeedleReturnProduction(): Promise<CommonResponseModel> {
            return await this.service.getAllNeedleReturnProduction();
    }


    @Post('/updateNeedleReturnProduction')
    @ApiBody({ type: NeedleReturnAfterProductionDto})
    async updateNeedleReturnProduction(@Body() req: any): Promise<CommonResponseModel> {
        return await this.service.updateNeedleReturnProduction(req);
    }

    @Post('/deleteNeedleReturnProduction')
    @ApiBody({ type: NeedleReturnAfterProductionDto})
    async deleteNeedleReturnProduction(@Body() req: any): Promise<CommonResponseModel> {
        return await this.service.deleteNeedleReturnProduction(req);
    }

    @Post('/getActiveNeedleReturnProduction')
    async getActiveNeedleReturnProduction(): Promise<CommonResponseModel> {
        return await this.service.getActiveNeedleReturnProduction();
    }

    @Post('/activateOrDeactivateNeedleReturnProduction')
    @ApiBody({ type:NeedleReturnAfterProductionDto})
    async activateOrDeactivateNeedleReturnProduction(@Body() dto:any): Promise<CommonResponseModel> {
        return await this.service.activateOrDeactivateNeedleReturnProduction(dto);
    }

    @Post('/getAllNeedleReturnReport')
    async getAllNeedleReturnReport(@Body() dto:any): Promise<CommonResponseModel> {
        return await this.service.getAllNeedleReturnReport(dto);
    }


}
